import bootbox from 'bootbox';
import $ from "jquery";
import React from 'react';
import ReactDOM from 'react-dom';
import Toastr from 'toastr';
import SessionManager from "../../routes/SessionManager";
import DropdownButton from '../bootstrap4/DropdownButton';
import Loading from '../Loading';
import DateUtil from '../../util/DateUtil';
import { Radio, Select } from 'antd';
import ProcoreLogo from '../../assets/img/procore_logo.svg';

class AppConnectors extends React.Component {
    constructor() {
        super();

        this.sessionManager = new SessionManager();
        this.user = this.sessionManager.readCookie('user');

        var site_id = new URL(window.location).searchParams.get('site_id');
        let forceSignIn = false;
        this.forceSignInCaptureInProgress = false;
        this.code = new URL(window.location).searchParams.get('code');
        if (site_id) {
            if (site_id.endsWith('I')) {
                this.forceSignInCaptureInProgress = true;
                site_id = site_id.substring(0, site_id.length - 1);
                forceSignIn = true;
            }
            this.user.site_id = site_id;
        }

        this.daily_log_defaults = {
            start_add_report: [],
            end_add_report: [],
            add_timelapse: [],
            start_work_hours: [],
            end_work_hours: []
        }

        this.image_folders_original = null;

        for (let i = 0, j = 12; i < 12; i++, j++) {
            this.daily_log_defaults.start_work_hours.push({ start_work_hours: i + '', val: (i === 0 ? 12 : i) + ' AM' });
            this.daily_log_defaults.end_work_hours.push({ end_work_hours: j + '', val: (j === 12 ? j : j - 12) + ' PM' });
        }

        this.defaultDailyLog = {
            site_owners: {},
            daily_log:
            {
                add_images: '1',
                add_timelapse: '16',
                add_weather: '1',
                add_report: "11 16",
                locations: []
            },
            include_weekends: '6 7',
            work_hours: "7 17",
            admin_status: 'disabled',
            notify_down: true
        };
        this.prepareDefaults(undefined, this.user.site_selected);
        this.state = {
            user: { ...this.user }, site_locations: [],
            procore: {
                ...this.defaultDailyLog
            },
            has_daily_log: false,
            isMounted: false
        };

        this.zones = this.user.zones;

        let url = window.location.href;
        if (url.indexOf('/site-management') > 0)
            url = url.substring(0, url.indexOf('/site-management')).replace('3000', '9000');
        if (url.indexOf('/settings') > 0)
            url = url.substring(0, url.indexOf('/settings')).replace('3000', '9000');

        this.server_url = url;

        if (this.code) {
            let xxx = this;
            setTimeout(function () {
                xxx.initProcoreIntegration({ site_id: site_id, code: xxx.code, force_signin: forceSignIn });
            }, 2000);
            this.showProcoreSplashScreen('Procore Integration in progress');
        }

        if (this.state.user.customer_id && !this.state.user.customer) {
            this.fetchCustomerDetails();
        } else {
            this.isProcoreUser = this.state.user && this.state.user.customer && this.state.user.customer.customer_application;
        }
    }

    fetchCustomerDetails() {
        let criteria = { "from": 0, "size": 1, customer_id: this.state.user.customer_id };
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/customer/fetch',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    source: 'D',
                    criteria: criteria,
                    "user_type": "user",
                    user_login: this.state.user.user_login,
                    user_token: this.state.user.user_token,
                    app_name: 'SITESUPT'
                })
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.records.length > 0) {
                        let user = this.sessionManager.readCookie('user');
                        user.customer = res.data.records[0];
                        this.isProcoreUser = user.customer && user.customer.customer_application;
                        this.sessionManager.storeCookie('user', user);
                        this.setState({ user: user });
                    }
                }
            },
            (res) => {

            });
    }

    prepareDefaults(work_hours = [7, 17], site_selected) {
        if (site_selected) {
            let { work_hours_start, work_hours_end, include_weekends } = DateUtil.getConfiguredWorkHours(site_selected).work_hours;
            const _work_hours = parseInt(work_hours_start.replace(":00", "")) + " " + parseInt(work_hours_end.replace(":00", ""));
            this.defaultDailyLog = { ...this.defaultDailyLog, work_hours: _work_hours, include_weekends }
            work_hours = _work_hours.split(" ");
        }
        this.daily_log_defaults.start_add_report = [{ start_add_report: 'None', val: 'None' }];
        this.daily_log_defaults.end_add_report = [{ end_add_report: 'None', val: 'None' }];
        this.daily_log_defaults.add_timelapse = [{ add_timelapse: 'None', val: 'None' }];

        for (let i = parseInt(work_hours[0]); i < 12; i++) {
            this.daily_log_defaults.start_add_report.push({ start_add_report: i + '', val: (i === 0 ? 12 : i) + ' AM' });
        }
        for (let j = 0; j <= (parseInt(work_hours[1]) - 12); j++) {
            this.daily_log_defaults.end_add_report.push({ end_add_report: (j + 12) + '', val: (j === 0 ? 12 : j) + ' PM' });
            this.daily_log_defaults.add_timelapse.push({ add_timelapse: (j + 12) + '', val: (j === 0 ? 12 : j) + ' PM' });
        }
    }

    componentDidMount() {
        this.setState({ isMounted: true });
        // this.fetchSiteLocations();
    }

    showProcoreSplashScreen(message) {
        bootbox.dialog({
            message: '<span class="text-primary"><i class="fa fa-spin fa-lg fa-circle-notch mr-2"></i>' + message + '</span>',
            closeButton: false,
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: 'hide btn-status-procore',
                    callback: function () {
                    }
                }
            }
        });
    }

    fetchSiteLocations() {
        var data = {
            customer_id: this.state.user.customer_id,
            site_id: this.state.user.user_sites,
            user_login: this.state.user.user_login,
            user_token: this.state.user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    this.setState({ site_locations: res.data }, function () {
                    });
                }
            },
            (res) => {

            });
    }

    onDefaultSiteChange = (site_selected) => {
        if (this.state.user.site_selected.site_id !== site_selected.site_id) {
            var user = { ...this.state.user };
            user.site_selected.site_id = site_selected.site_id;
            this.prepareDefaults(undefined, site_selected);
            this.hasProcoreAccess(user.site_selected.site_id);
            this.setState({ user: user, defaultSiteChanged: true }, function () {
            });
            //console.log('Site Selected :: ' + JSON.stringify(site_selected));
        }
    }

    saveDefaultSite = (event) => {
        var data = {
            form_input: { site_id: this.state.user.site_selected.site_id },
            customer_id: this.user.customer_id,
            user_login: this.user.user_login,
            user_token: this.user.user_token
        }

        var basicInputs = { site_id: null };
        for (var k in basicInputs) {
            if (data.form_input[k] == null) {
                Toastr.error('All fields are mandatory !');
                return;
            } else {
                basicInputs[k] = data.form_input[k];
            }
        }
        data.form_input = basicInputs;

        var saveBtn = event.target;
        saveBtn.innerHTML = 'Saving ...';
        saveBtn.disabled = true;

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/user/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success('Changes saved successfully !');
                }

                var sessionMgr = new SessionManager();
                var user = { ...this.state.user };
                delete user.defaultSiteChanged; // No need to store in cookie.
                delete user.site_selected; // Flush it to pick new default. 
                sessionMgr.storeCookie('user', user);

                this.setState({ user: user, defaultSiteChanged: false }, function () {
                    saveBtn.innerHTML = 'Save';
                    saveBtn.disabled = false;
                });
            },
            (res) => {
                saveBtn.innerHTML = 'Save';
                saveBtn.disabled = false;
            });
    }

    hasProcoreAccess(site_id) {
        $.ajax(
            {
                url: this.server_url + '/procore/user/' + site_id,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: this.state.user.user_login,
                    user_token: this.state.user.user_token
                }
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    // console.log('Procore Response ', res);
                    let site_owners = { ...this.state.procore.site_owners };
                    let obj = res.data[0];
                    let has_daily_log = true;
                    site_owners[site_id] = obj;
                    if (!obj.daily_log) {
                        has_daily_log = false;
                        obj.daily_log = { ...this.defaultDailyLog.daily_log };
                        obj.admin_status = this.defaultDailyLog.admin_status;
                        obj.notify_down = this.defaultDailyLog.notify_down;
                    }
                    obj.include_weekends = this.defaultDailyLog.include_weekends; //obj.include_weekends || this.defaultDailyLog.include_weekends;
                    obj.work_hours = this.defaultDailyLog.work_hours; //obj.work_hours || 

                    if (obj.image_folders !== undefined) {
                        this.image_folders_original = JSON.parse(JSON.stringify(obj.image_folders));
                    }

                    let fetchImageCategories = obj.image_folders && obj.image_folders.single_folder;

                    this.state.isMounted === true && (this.procore = { site_owners: site_owners, daily_log: obj.daily_log, include_weekends: obj.include_weekends, work_hours: obj.work_hours, admin_status: obj.admin_status, notify_down: obj.notify_down, login_required: obj.login_required, image_folders: obj.image_folders, locations: obj.locations });
                    this.setState({ image_folders_loading: fetchImageCategories, has_daily_log: has_daily_log, procore: { site_owners: site_owners, daily_log: obj.daily_log, include_weekends: obj.include_weekends, work_hours: obj.work_hours, admin_status: obj.admin_status, notify_down: obj.notify_down, login_required: obj.login_required, image_folders: obj.image_folders, locations: obj.locations }, isMounted: false }, function () {
                        if (fetchImageCategories) {
                            this.getImageFolders();
                        }
                    });
                } else {
                    //console.log('Procore Response Else ');
                    let site_owners = { ...this.state.procore.site_owners };
                    site_owners[site_id] = null;
                    this.setState({
                        has_daily_log: false,
                        procore: {
                            site_owners: site_owners,
                            daily_log: {
                                add_images: '1',
                                add_timelapse: '16',
                                add_weather: '1',
                                add_report: "11 16",
                            },
                            include_weekends: this.defaultDailyLog.include_weekends,
                            work_hours: this.defaultDailyLog.work_hours,
                            admin_status: 'enabled',
                            notify_down: true,
                            image_folders: null
                        }
                    });
                }
                setTimeout(() => $('[data-toggle="tooltip"]').tooltip(), 200);
            },
            (res) => {

            });
    }

    refreshTokenAtSiteLevel() {
        $.ajax(
            {
                url: (window.location.origin) + '/rest/v1.0/refresh-token-by-site-id/' + this.state.user.site_selected.site_id,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.errors) {
                        this.setState({ image_categories: null, image_folders_loading: false });
                        bootbox.confirm('Procore Access token expired and needs re-authentication to fetch image folders. Would you like to re-authenticate ?', (isYes) => {
                            if (isYes)
                                this.goToProcore(true);
                        });
                    } else {
                        this.getImageFolders();
                    }
                } else {
                    this.setState({ image_categories: null, image_folders_loading: false }, function () {
                    });
                }
            },
            (res) => {

            });
    }

    getImageFolders() {
        $.ajax(
            {
                url: this.server_url + '/procore/image-folders/' + this.state.user.site_selected.site_id,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: this.state.user.user_login,
                    user_token: this.state.user.user_token
                }
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200) {
                        if (res.data.errors) {
                            this.refreshTokenAtSiteLevel();
                        } else {
                            this.setState({ image_categories: res.data && res.data.length > 0 ? res.data : [{ name: "SiteKick", id: 0 }], image_folders_loading: false });
                        }
                    } else if (res.status.code === 401) {
                        this.setState({ image_categories: null, image_folders_loading: false });
                        Toastr.error("Procore Access Token expired ...");
                        this.goToProcore(true);
                    }
                } else {
                    this.setState({ image_categories: [], image_folders_loading: false });
                }
            },
            (res) => {
                Toastr.error("Error occured ...");
                this.setState({ image_folders_loading: false });
            });
    }

    initProcoreIntegration(site_code_obj) {
        //console.log("Server URL " + this.server_url);
        $.ajax(
            {
                url: this.server_url + '/procore/auth-token/',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(site_code_obj),
                headers: {
                    user_login: this.state.user.user_login,
                    user_token: this.state.user.user_token
                }
            }
        ).then(
            (res) => {
                $('#defaults-tab').trigger('click');
                $('.btn-status-procore').trigger('click');
                if (res.status) {
                    if (res.status.code === 200) {
                        let data = res.data;
                        this.forceSignInCaptureInProgress = false;
                        if (data.p_user) {
                            this.showProcoreSelections(data, res.level);
                        } else if (res.procore_integration === 'success') {

                            let site_owners = { ...this.state.procore.site_owners };
                            this.setState({
                                procore: {
                                    site_owners: site_owners,
                                    daily_log: {
                                        add_images: '1',
                                        add_timelapse: '16',
                                        add_weather: '1',
                                        add_report: "11 16",
                                    },
                                    include_weekends: this.defaultDailyLog.include_weekends,
                                    work_hours: this.defaultDailyLog.work_hours,
                                    admin_status: 'enabled',
                                    notify_down: true
                                }
                            }, function () {
                                this.hasProcoreAccess(site_code_obj.site_id);
                            });

                            Toastr.success('Procore Integration successful !');
                        }
                    } else if (res.status.code === 201) {
                        this.forceSignInCaptureInProgress = false;
                        Toastr.error('Error : ' + res.status.message);
                        setTimeout(function () {
                            $('.btn-status-procore').trigger('click');
                        }, 1000)
                    }
                }
            },
            (res) => {
                this.forceSignInCaptureInProgress = false;
                setTimeout(function () {
                    $('.btn-status-procore').trigger('click');
                }, 1000)
                $('#defaults-tab').trigger('click');
                Toastr.error('Procore integration failed ... <br>Please try again !');
            })
    }

    onProcoreSelection = (obj, select_type, el) => {
        console.log([obj, select_type, el]);
        this[select_type] = obj;
        //$(el.target).closest('#procore_selector').find('button').html(obj['name']);
        return true;
    }

    showProcoreSelections(data, select_type) {
        this.company = null;
        // let content = <DropdownButton
        //     className="btn btn-sm dropdown-toggle text-dark p-2"
        //     onOptionClick={(obj, el) => this.onProcoreSelection(obj, select_type, el)}
        //     default={"Choose " + select_type}
        //     selected={""}
        //     opts={data[select_type]}
        //     field_attr='id'
        //     value_attr='name' />;

        let content = <Select placeholder={"Choose " + select_type} options={data[select_type]} style={{ minWidth: '250px' }} fieldNames={{ label: 'name', value: 'id' }} onChange={(v, opt) => this.onProcoreSelection(opt, select_type, null)} />

        let _context = this;
        bootbox.dialog({
            title: 'Choose ' + select_type,
            message: "<div id='procore_selector'></div>",
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: 'btn-default btn-close-procore',
                    callback: function () {

                    }
                },
                ok: {
                    label: "Save",
                    className: 'btn-primary btn-save-procore',
                    callback: function () {
                        _context.saveProcoreSelection(data, select_type);
                        return false;
                    }
                }
            }
        });

        setTimeout(function () {
            ReactDOM.render(content, document.getElementById('procore_selector'));
        }, 1000);
    }

    isModified = () => {
        let isModified = false;
        const defaultSite = this.state.user ? this.state.user.site_selected.site_id : '';
        let hasSiteOwner = this.state.procore.site_owners[defaultSite] !== undefined;
        isModified = (hasSiteOwner && this.procore && (JSON.stringify(this.procore.daily_log) !== JSON.stringify(this.state.procore.daily_log) || JSON.stringify(this.procore.notify_down) !== JSON.stringify(this.state.procore.notify_down) || JSON.stringify(this.procore.include_weekends) !== JSON.stringify(this.state.procore.include_weekends) || JSON.stringify(this.procore.image_folders) !== JSON.stringify(this.state.procore.image_folders)));
        return isModified;
    }

    saveProcoreSelection(data, select_type) {
        data[select_type + '_id'] = this[select_type]['id'];
        data[select_type] = this[select_type];

        //console.log(JSON.stringify(data));

        $('.btn-close-procore').addClass('hide');
        $('.btn-save-procore').html('<i class="fa fa-spin fa-lg fa-circle-notch mr-2"></i> Saving ...');

        $.ajax(
            {
                url: this.server_url + '/procore/save-' + select_type,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data),
                headers: {
                    user_login: this.state.user.user_login,
                    user_token: this.state.user.user_token
                }
            }
        ).then(
            (res) => {
                $('.btn-close-procore').trigger('click');
                if (res.status && res.status.code === 200) {
                    let data = res.data;
                    if (data.p_user) {
                        this.showProcoreSelections(data, res.level);
                    } else if (res.procore_integration === 'success') {
                        let site_owners = { ...this.state.procore.site_owners };
                        this.setState({
                            procore: {
                                site_owners: site_owners,
                                daily_log: {
                                    add_images: '1',
                                    add_timelapse: '16',
                                    add_weather: '1',
                                    add_report: "11 16",
                                },
                                include_weekends: this.defaultDailyLog.include_weekends,
                                work_hours: this.defaultDailyLog.work_hours,
                                admin_status: 'enabled',
                                notify_down: true
                            }
                        }, function () {
                            this.hasProcoreAccess(this.state.user.site_selected.site_id);
                        });
                        Toastr.success('Procore Integration successful !');
                    }
                }
            },
            (res) => {

            });
    }

    deleteProcoreIntegration = () => {
        let _context = this;
        bootbox.confirm('Are you sure you want to sign out ?', function (isYes) {
            if (!isYes)
                return;

            _context.showProcoreSplashScreen('Sign out from procore account in progress ...');
            $.ajax(
                {
                    url: _context.server_url + '/procore/' + _context.state.user.site_selected.site_id,
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    headers: {
                        user_login: _context.state.user.user_login,
                        user_token: _context.state.user.user_token
                    }
                }
            ).then(
                (res) => {
                    $('.btn-close-procore').trigger('click');
                    $('.btn-status-procore').trigger('click');
                    if (res.status && res.status.code === 200) {
                        Toastr.success('Signed out from Procore account !');

                        let site_owners = { ..._context.state.procore.site_owners };
                        delete site_owners[_context.state.user.site_selected.site_id];

                        _context.setState({
                            image_categories: null,
                            procore: {
                                site_owners: site_owners,
                                daily_log: {
                                    add_images: '1',
                                    add_timelapse: '16',
                                    add_weather: '1',
                                    add_report: "11 16",
                                },
                                include_weekends: _context.defaultDailyLog.include_weekends,
                                work_hours: _context.defaultDailyLog.include_weekends,
                                admin_status: 'enabled',
                                notify_down: true,
                                image_folders: null,
                            }
                        }, function () {
                            _context.hasProcoreAccess(_context.state.user.site_selected.site_id);
                        });

                        setTimeout(() => $('.btn-status-procore').trigger('click'), 2000);
                    }
                },
                (res) => {
                    setTimeout(() => $('.btn-status-procore').trigger('click'), 2000);
                });
        });
    }

    goToProcore = (forceSignIn = false) => {
        console.log('forceSignIn ' + JSON.stringify(forceSignIn));
        window.location = "https://login.procore.com/oauth/authorize?client_id=3e1ca11c1bea250d7b79c5f3ff6c759b8b606643b1a95460e102267354310e2a&response_type=code&redirect_uri=" + this.server_url + "/settings?site_id=" + this.state.user.site_selected.site_id + (forceSignIn ? 'I' : '');
    }

    onSelectionChange = (obj, key) => {

        let val = '0';
        let flds = ['include_weekends', 'start_work_hours', 'end_work_hours', 'admin_status', 'notify_down'];
        let procore = { ...this.state.procore };
        let procoreLevel = (flds.indexOf(key) !== -1);

        // console.log('value of ' + key + ' is : ' + obj[key]);
        // console.log('Before : ' + JSON.stringify(procore, null, 4));

        if (key.indexOf('start') === 0 || key.indexOf('end') === 0) {
            let combiKey = key.replace('start_', '').replace('end_', '');

            val = (procore[combiKey] || procore.daily_log[combiKey]).split(' ');
            console.log('combiKey ' + combiKey + ' and val is ' + val);
            if (key.indexOf('start') === 0) {
                val[0] = obj[key];

                if (combiKey === 'work_hours') {
                    let curr = (procore.daily_log['add_report']).split(' ');
                    if (parseInt(curr[0]) < parseInt(obj[key])) {
                        curr[0] = obj[key];
                        procore.daily_log['add_report'] = curr.join(' ');
                    }
                }

            } else {
                val[1] = obj[key];

                if (combiKey === 'work_hours') {
                    let curr = (procore.daily_log['add_report']).split(' ');
                    if (parseInt(curr[1]) > parseInt(obj[key])) {
                        curr[1] = obj[key];
                        procore.daily_log['add_report'] = curr.join(' ');
                    }
                    let curr1 = this.state.procore.daily_log['add_timelapse'];
                    if (parseInt(curr1) > parseInt(obj[key])) {
                        procore.daily_log['add_timelapse'] = obj[key];
                    }
                }
            }

            if (combiKey === 'work_hours')
                this.prepareDefaults(val);

            val = val.join(' ');
            key = combiKey;
        } else {
            val = obj[key];
        }

        if (procoreLevel)
            procore[key] = val;
        else
            procore.daily_log[key] = val;

        // console.log('After : ' + JSON.stringify(procore, null, 4));
        this.setState({ procore: procore });
    }

    saveDailyLogSettings = () => {
        let daily_log = { ...this.state.procore.daily_log };
        let data = {};
        data.site_id = this.state.user.site_selected.site_id;
        data.daily_log = daily_log;
        data.include_weekends = this.state.procore.include_weekends;
        data.work_hours = '0 23';//this.state.procore.work_hours;
        data.admin_status = this.state.has_daily_log ? this.state.procore.admin_status : 'enabled';
        data.notify_down = this.state.procore.notify_down;
        data.image_folders = this.state.procore.image_folders;
        data.locations = this.state.procore.daily_log.locations;

        if (data.image_folders && data.image_folders.single_folder) {
            if (data.image_folders.single_folder === true) {
                if (this.state.image_folders_loading) {
                    Toastr.error("Image folders are still loading ...Please choose image folder and then click save.");
                    return;
                }

                if (this.state.image_categories) {
                    let folderFound = false;
                    for (let x of this.state.image_categories)
                        if (x.id === data.image_folders.single_folder_id)
                            folderFound = true;

                    if (!folderFound) {
                        Toastr.error("Invalid image folder ...");
                        return;
                    }
                }
            }
        }

        //console.log(JSON.stringify(data, null, 4));

        // if (event) {
        //     var saveBtn = event.target;
        //     saveBtn.innerHTML = 'Saving ...';
        //     saveBtn.disabled = true;
        // }

        var saveBtn = document.getElementById('save-dailylog');
        saveBtn.innerHTML = 'Saving ...';
        saveBtn.disabled = true;

        $.ajax(
            {
                url: this.server_url + '/procore/save-datalog-settings',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data),
                headers: {
                    user_login: this.state.user.user_login,
                    user_token: this.state.user.user_token
                }
            }
        ).then(
            (res) => {
                $('.btn-close-procore').trigger('click');
                if (res.status && res.status.code === 200) {
                    Toastr.success('Settings saved sucessfully !');
                    this.hasProcoreAccess(this.state.user.site_selected.site_id);
                    this.procore = this.state.procore
                } else {
                    Toastr.error('Error occured !');
                }

                saveBtn.innerHTML = 'Save';
            },
            (res) => {
                Toastr.error('Error occured !');
                saveBtn.innerHTML = 'Save';
                saveBtn.disabled = false;
            });
    }

    enableOrDisableProcore = (event) => {
        let checkbox = $(event.target);
        let procore = { ...this.state.procore };
        procore.admin_status = checkbox.hasClass('fa-check-square') ? 'disabled' : 'enabled';
        this.setState({ procore: procore });
    }

    enableOrDisableNotifyDown = (event) => {
        let checkbox = $(event.target);
        let procore = { ...this.state.procore };
        procore.notify_down = !checkbox.hasClass('fa-check-square');
        this.setState({ procore: procore });
    }

    getStandardTime = (work_hours) => {
        return parseInt(work_hours) < 12 ? (work_hours === '0' ? '12' : (work_hours)) + ' AM' : (work_hours === '12' ? '12' : parseInt(work_hours) - 12) + ' PM';
    }

    imageFoldersOnChange = (e) => {
        let procore = this.state.procore;

        if (this.image_folders_original) {
            procore.image_folders = JSON.parse(JSON.stringify(this.image_folders_original));
        }

        switch (e.target.value) {
            case 1:
                if (procore.image_folders === undefined || !procore.image_folders)
                    procore.image_folders = {};

                procore.image_folders.single_folder = true;
                if (this.state.image_categories == null)
                    this.getImageFolders();

                this.setState({ procore: procore, image_folders_loading: this.state.image_categories == null }, () => console.log('this.state.procore', this.state.procore));
                break;

            case 0:
                if (procore.image_folders === undefined || !procore.image_folders)
                    procore.image_folders = {};

                procore.image_folders.single_folder = false;
                procore.image_folders.single_folder_id = 0;
                this.setState({ procore: procore }, () => console.log('this.state.procore', this.state.procore));
                break;

            default:
                procore.image_folders = null;
                this.setState({ procore: procore }, () => console.log('this.state.procore', this.state.procore));
                break;
        }

    }

    onImageFolderSelected = (i) => {
        let procore = this.state.procore;
        procore.image_folders.single_folder = true;
        procore.image_folders.single_folder_id = i;
        this.setState({ procore: procore }, () => console.log('this.state.procore', this.state.procore));
    }

    render() {
        const defaultSite = this.state.user ? this.state.user.site_selected.site_id : '';
        if (defaultSite !== '' && this.state.procore.site_owners[defaultSite] === undefined) {
            if (!this.forceSignInCaptureInProgress)
                this.hasProcoreAccess(defaultSite);
            //console.log('this.state.user.user_login ' + this.state.user.user_login);
            //console.log('this.state.procore.site_owners ' + JSON.stringify(this.state.procore.site_owners[defaultSite]));
        }
        const siteOwnerProcore = this.state.procore.site_owners[defaultSite];
        let allowSignIn = false;
        let isOwner = false;
        let forceSignIn = false;
        let ownerId = null;
        if (siteOwnerProcore === undefined || !siteOwnerProcore) {
            allowSignIn = true;
        } else if (siteOwnerProcore) {
            allowSignIn = false;
            if (siteOwnerProcore['user_id'] === this.state.user.user_login) {
                forceSignIn = this.state.procore.login_required;
                isOwner = true;
            } else {
                isOwner = false;
                ownerId = siteOwnerProcore['user_id'];
            }
        }

        //console.log(this.state.procore);
        //console.log('isOwner ' + isOwner + ' signedIn ' + allowSignIn);

        let hasSiteOwner = this.state.procore.site_owners[defaultSite] !== undefined;

        // let start_work_hours = (this.state.procore.work_hours).split(' ')[0];
        // start_work_hours = this.getStandardTime(start_work_hours);

        // let end_work_hours = (this.state.procore.work_hours).split(' ')[1];
        // end_work_hours = this.getStandardTime(end_work_hours);

        let start_add_report = (this.state.procore.daily_log.add_report).split(' ')[0];
        if (start_add_report !== 'None')
            start_add_report = (start_add_report === '0' ? '12' : (start_add_report)) + ' AM';

        let end_add_report = (this.state.procore.daily_log.add_report).split(' ')[1];
        if (end_add_report !== 'None')
            end_add_report = (end_add_report === '12' ? '12' : parseInt(end_add_report) - 12) + ' PM';

        let add_timelapse = this.state.procore.daily_log.add_timelapse;
        if (add_timelapse !== 'None')
            add_timelapse = (add_timelapse === '12' ? '12' : (add_timelapse) - 12) + ' PM';

        let adminStatusCSS = this.state.procore.admin_status === 'enabled' ? 'fa fa-lg fa-checkbox fa-check-square' : 'far fa-lg fa-checkbox fa-square';
        let notifyDownCSS = this.state.procore.notify_down ? 'fa fa-lg fa-checkbox fa-check-square' : 'far fa-lg fa-checkbox fa-square';
        //console.log('this.state ' + JSON.stringify(this.state.procore, null, 4));

        if (this.isProcoreUser) {
            //console.log('Yes ...procore user');
            $('#app-connectors').removeClass('hide');
            $('#app-connectors-tab').parent().removeClass('hide');
        }

        let singleImageFolder = '';
        if (this.state.procore.image_folders && this.state.procore.image_folders.single_folder &&
            this.state.image_categories && this.state.image_categories.length > 0) {

            for (let x of this.state.image_categories)
                if (this.state.procore.image_folders.single_folder_id === x.id)
                    singleImageFolder = x.id;
        }

        let imageFolderType = this.state.procore.image_folders;

        if (this.state.procore.image_folders) {
            if (this.state.procore.image_folders.single_folder !== undefined) {
                if (this.state.procore.image_folders.single_folder === true) {
                    imageFolderType = 1;
                } else if (this.state.procore.image_folders.single_folder === false) {
                    imageFolderType = 0;
                }
            } else {
                imageFolderType = -1;
            }
        } else {
            imageFolderType = -1;
        }

        // console.log('imageFolderType', imageFolderType);

        return (
            <React.Fragment>
                {
                    this.isProcoreUser &&
                    <React.Fragment>
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link p-1 px-3 active text-procore text-bold" id="procore-tab" data-toggle="tab" href="#procore" role="tab" aria-controls="procore" aria-selected="true"><img src={ProcoreLogo} width="18" height="18" alt="Procore" /> My Procore</a>
                            </li>
                        </ul>
                        <div className="tab-content border-light p-3">
                            <div className="tab-pane fade show active" id="procore" role="tabpanel" aria-labelledby="profile-tab">
                                <div className="row" style={{ marginBottom: "30px" }}>
                                    <div className="col-md-12">
                                        <span><b>NOTE:</b> My Procore assists you with automatically completing your Daily Logs. <br /><b style={{ visibility: "hidden" }}>NOTE:</b> SiteSupt.com does not store, expose or keep your Procore private identity credentials.</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <b>Site Name</b> :  {this.state.user.site_selected.site_name}
                                    </div>
                                </div>
                                {
                                    forceSignIn &&
                                    <b>
                                        <i className="fa fa-warning text-danger"></i> Procore Integration for this site is disconnected. Please SignIn again to reconnect.<br />
                                        <button onClick={() => this.goToProcore(true)} className="btn btn-procore btn-sm mt-2">SIGNIN INTO YOUR PROCORE ACCOUNT TO CONNECT</button>
                                    </b>
                                }

                                {!forceSignIn &&
                                    (!allowSignIn && isOwner) &&
                                    <div className="row">
                                        <div className="col-md-12">
                                            <b>Customer</b> : {this.state.procore.site_owners[this.state.user.site_selected.site_id] ? this.state.procore.site_owners[this.state.user.site_selected.site_id].company_name : ''}<br />
                                            <b>Project</b> : {this.state.procore.site_owners[this.state.user.site_selected.site_id] ? this.state.procore.site_owners[this.state.user.site_selected.site_id].project_name : ''}<br />
                                        </div>
                                    </div>
                                }

                                {!forceSignIn && isOwner &&
                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            Enable Procore Integration : <span onClick={this.enableOrDisableProcore} className={'text-primary ' + adminStatusCSS}></span>
                                        </div>
                                    </div>
                                }

                                {!forceSignIn && (siteOwnerProcore !== undefined && !forceSignIn) &&
                                    <div className="row">
                                        <div className="col-md-12 p-3">
                                            <button disabled={(!allowSignIn)} onClick={(e) => this.goToProcore(forceSignIn)} className={allowSignIn ? "btn btn-procore btn-sm" : "btn btn-sm btn-disabled"}>SIGNIN INTO YOUR PROCORE ACCOUNT TO CONNECT</button>
                                            <button disabled={allowSignIn} onClick={!isOwner ? null : this.deleteProcoreIntegration} data-toggle="tooltip" title={ownerId ? "Only " + ownerId.toUpperCase() + " can signout from procore account or contact SiteSupt Support." : ""} className={!allowSignIn ? (isOwner ? "btn btn-procore btn-sm ml-3" : "btn btn-sm ml-3 btn-procore btn-not-allowed") : "btn btn-sm ml-3 btn-disabled"}> {(!allowSignIn && !isOwner) && <i className="fa fa-ban"></i>} SIGNOUT FROM YOUR PROCORE ACCOUNT</button>
                                        </div>
                                    </div>
                                }
                                {!forceSignIn && !hasSiteOwner && <Loading className="mt-3"> Fetching Procore Details ...</Loading>}
                            </div>
                        </div>


                        {!forceSignIn && isOwner && !allowSignIn && <React.Fragment>
                            <div className="text-bold p-2 mt-4 bg-light" >Daily Log Submissions Settings</div>
                            {
                                !this.state.has_daily_log && <div className="row">
                                    <div className="col-md-12 data-log d-inline">
                                        <i className="fa fa-warning text-warning"></i> <div className="d-inline">Your procore integration is completed. However, there are no data log submission settings to publish SiteSupt content to your Procore account. <br />Please click below button and add your data log submission settings.</div>
                                        <div className="text-center mt-3">
                                            <button className="btn btn-primary btn-sm" onClick={(e) => { $('#data_log_settings').toggleClass('hide show'); $('.data-log').toggleClass('hide d-inline'); }}>Create DataLog Submission Settings</button>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div id="data_log_settings" className={this.state.has_daily_log ? 'show border-light' : 'hide'}>
                                {/* <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Work Hours : </label> {start_work_hours} <label className="d-inline"> To </label> {end_work_hours}
                                    </div>
                                </div> 
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Include Weekends as work days : </label><DropdownButton
                                            className="btn btn-sm dropdown-toggle text-dark p-2 d-inline"
                                            default={""}
                                            selected={this.state.procore.include_weekends}
                                            onOptionClick={(obj) => this.onSelectionChange(obj, 'include_weekends')}
                                            opts={[
                                                { include_weekends: '0', val: 'No' },
                                                { include_weekends: '6', val: 'Saturdays' },
                                                { include_weekends: '7', val: 'Sundays' },
                                                { include_weekends: '6 7', val: 'Saturdays, Sundays' }
                                            ]}
                                            field_attr='include_weekends'
                                            value_attr='val' />
                                    </div>
                                </div>
                               */}
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Add best fit Images into Photos section : </label><DropdownButton
                                            className="btn btn-sm dropdown-toggle text-dark p-2 d-inline"
                                            default={""}
                                            selected={this.state.procore.daily_log.add_images}
                                            onOptionClick={(obj) => this.onSelectionChange(obj, 'add_images')}
                                            opts={[
                                                { add_images: '0', val: 'No' },
                                                { add_images: '1', val: 'Every 1 hour' },
                                                { add_images: '2', val: 'Every 2 hours' },
                                                { add_images: '3', val: 'Every 3 hours' },
                                                { add_images: '4', val: 'Every 4 hours' },
                                                { add_images: '5', val: 'Every 5 hours' },
                                                { add_images: '6', val: 'Every 6 hours' },
                                            ]}
                                            field_attr='add_images'
                                            value_attr='val' />
                                    </div>
                                </div>
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Add Standard Daily Report PDF to Notes section on : </label>

                                        <DropdownButton
                                            className="btn btn-sm dropdown-toggle text-dark p-2 d-inline"
                                            default={start_add_report}
                                            onOptionClick={(obj) => this.onSelectionChange(obj, 'start_add_report')}
                                            opts={this.daily_log_defaults.start_add_report}
                                            field_attr='start_add_report'
                                            value_attr='val' />

                                        <div className="d-inline"> and </div>

                                        <DropdownButton
                                            className="btn btn-sm dropdown-toggle text-dark p-2 d-inline"
                                            default={end_add_report}
                                            onOptionClick={(obj) => this.onSelectionChange(obj, 'end_add_report')}
                                            opts={JSON.parse(JSON.stringify(this.daily_log_defaults.end_add_report))}
                                            field_attr='end_add_report'
                                            value_attr='val' />
                                    </div>
                                </div>
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Add Time Laps day videos to Notes section at : </label><DropdownButton
                                            className="btn btn-sm dropdown-toggle text-dark p-2 d-inline"
                                            default={add_timelapse}
                                            onOptionClick={(obj) => this.onSelectionChange(obj, 'add_timelapse')}
                                            opts={this.daily_log_defaults.add_timelapse}
                                            field_attr='add_timelapse'
                                            value_attr='val' />
                                    </div>
                                </div>
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Image Categories : </label>
                                        <Radio.Group onChange={(e) => this.imageFoldersOnChange(e)} value={imageFolderType}>
                                            <Radio value={-1}>Daily Folder For All Images (Default)</Radio>
                                            <Radio value={0}>Single Folder Per Zone Images</Radio>
                                            <Radio value={1}>Single Folder For All Images</Radio>
                                        </Radio.Group>
                                        {this.state.procore.image_folders && this.state.procore.image_folders.single_folder &&
                                            <Select
                                                style={{ width: 250 }}
                                                showSearch={this.state.image_categories && this.state.image_categories.length > 0 ? true : false}
                                                filterOption={(input, option) =>
                                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                value={singleImageFolder}
                                                loading={this.state.image_folders_loading}
                                                onChange={this.onImageFolderSelected}
                                                options={this.state.image_categories ? this.state.image_categories.map((a) => { return { value: a.id, label: a.name }; }) : []}
                                                placeholder={!this.state.image_categories ? "Fetching Image Folders" : this.state.image_categories.length > 0 ? "Choose Folder" : ''} />
                                        }
                                    </div>
                                </div>
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline"> Select Zone(s) : </label>
                                        <Select
                                            mode="multiple"
                                            virtual={false}
                                            style={{ width: '80%' }}
                                            placeholder="Choose Zone"
                                            size='middle'
                                            defaultValue={this.state.procore.daily_log.locations}
                                            options={this.zones.length > 0 ? this.zones.map((z) => { return { value: z.location_id, label: z.location_name } }) : []}
                                            onChange={(loc_ids) => {
                                                var procore = { ...this.state.procore }
                                                procore.daily_log.locations = loc_ids;
                                                this.setState({ procore });
                                            }}
                                        />
                                    </div>
                                </div>
                                <small className="pl-4"><i className="fa fa-lg fa-info-circle text-primary"></i> If none of the zones are selected, by default all zones are included.</small>
                                {/* <div className="row my-3 ml-2">
                                <div className="col-md-12">
                                    <div className="d-inline">Add Weather updates to Observed Weather section : </div><DropdownButton
                                        className="btn btn-sm dropdown-toggle text-dark p-2 d-inline"
                                        default={"Every 5 hour"}
                                        selected={this.state.procore.daily_log.add_weather}
                                        onOptionClick={(obj) => this.onSelectionChange(obj, 'add_weather')}
                                        opts={[
                                            { add_weather: '0', val: 'No' },
                                            { add_weather: '1', val: 'Every 1 hour' },
                                            { add_weather: '2', val: 'Every 2 hours' },
                                            { add_weather: '3', val: 'Every 3 hours' },
                                            { add_weather: '4', val: 'Every 4 hours' },
                                            { add_weather: '5', val: 'Every 5 hours' },
                                            { add_weather: '6', val: 'Every 6 hours' },
                                        ]}
                                        field_attr='add_weather'
                                        value_attr='val' />
                                </div>
                            </div> */}
                                <div className="row my-3 ml-2">
                                    <div className="col-md-12">
                                        <label className="d-inline">Add Zone status to Notes section if disconnected : </label>
                                        <span onClick={this.enableOrDisableNotifyDown} className={'text-primary ' + notifyDownCSS}></span>
                                    </div>
                                </div>
                                <div className="row mb-3 ml-4">
                                    <div className="col-md-12 text-center">
                                        <button id="save-dailylog" disabled={!isOwner || !this.isModified()} className="btn btn-sm btn-primary" onClick={isOwner ? this.saveDailyLogSettings : null}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>}
                    </React.Fragment>
                }

            </React.Fragment>
        );
    }
}

export default AppConnectors;